import { useCheckActions } from "../actions/checkActions"
import { useCheckBuilders } from "../builders/checkBuilders"
import { useCheckLoaders } from "../loaders/checkLoaders"

export const useCheckService = () => {
    const { buildCheck } = useCheckBuilders()

    const checkLoaders = useCheckLoaders()

    const { saveCheck } = useCheckActions()

    const archiveCheck = async (checkId: string) => {
        const { loadCheck } = checkLoaders()
        const check = await loadCheck(checkId, true)
        const archivedCheck = buildCheck({
            ...check,
            archived: true
        })
        return saveCheck(archivedCheck)
    }

    return {
        archiveCheck
    }
}
